import React, { useCallback, useMemo } from "react";
import { spaceCategories } from "_constants";
import sortBy from "lodash/sortBy";
import uniq from "lodash/uniq";
import PropTypes from "prop-types";

import SpaceLabel from "components/SpaceLabel";
import Translate from "utils/translate";

import TitledMultiDropdown from "../TitledMultiDropdown";

const { t } = new Translate("TitledSpacesDropdown");

const getTags = (spaces, withAsset) =>
  spaces.map((space) =>
    withAsset && space.asset ? `${space.asset.name} - ${space.name}` : space.name
  );

const TitledSpacesDropdown = (props) => {
  const {
    emptyText,
    isEdit,
    isMultiple,
    isOpen,
    isRequired,
    onEdit,
    onSelect,
    selectedSpaces,
    spaces,
    title,
  } = props;

  const handleEdit = useCallback(() => {
    if (onEdit) {
      onEdit();
    }
  }, [onEdit]);

  const hasMultipleAssets = useMemo(
    () => uniq(spaces.map((space) => space.assetId)).length > 0,
    [spaces]
  );

  const sortedSpaces = useMemo(
    () =>
      sortBy(spaces, [
        (space) => Boolean(space.asset) && space.asset.name,
        (space) => spaceCategories[space.category].position,
      ]),
    [spaces]
  );

  return (
    <TitledMultiDropdown
      emptyText={emptyText}
      inputComponentProps={{
        tags: getTags(selectedSpaces, hasMultipleAssets),
        limit: 5,
      }}
      isEdit={isEdit}
      isMultiple={isMultiple}
      isOpen={isOpen}
      isRequired={isRequired}
      keyExtractor={(s) => s.id || s.spaceId}
      onEdit={handleEdit}
      onSelect={onSelect}
      selectedValues={selectedSpaces}
      title={title}
      valueExtractor={(space) => (
        <SpaceLabel key={space.id} space={space} withAsset={hasMultipleAssets} isExtended />
      )}
      values={sortedSpaces}
      expandValues
    />
  );
};

TitledSpacesDropdown.propTypes = {
  emptyText: PropTypes.string,
  title: PropTypes.string,
  spaces: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired, // eslint-disable-line
      size: PropTypes.shape({
        value: PropTypes.number.isRequired, // eslint-disable-line
        unit: PropTypes.string.isRequired, // eslint-disable-line
      }),
    })
  ).isRequired,
  selectedSpaces: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired, // eslint-disable-line
      size: PropTypes.shape({
        value: PropTypes.number.isRequired, // eslint-disable-line
        unit: PropTypes.string.isRequired, // eslint-disable-line
      }),
    })
  ),
  isOpen: PropTypes.bool,
  isEdit: PropTypes.bool,
  isRequired: PropTypes.bool,
  isMultiple: PropTypes.bool,
  onEdit: PropTypes.func,
  onSelect: PropTypes.func.isRequired,
};

TitledSpacesDropdown.defaultProps = {
  selectedSpaces: [],
  emptyText: t("emptyText.spacesDeal"),
};

export default TitledSpacesDropdown;
